import request from "../utils/request";

export function GET_MyTaskList(token, payload) {
  return request.get("/MyTask/List", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function PUT_MyTaskProgress(token, formData) {
  return request.put("/MyTask/Progress", formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function POST_MyTaskProgress(token, formData) {
  return request.post("/MyTask/Progress", formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function GET_MyTaskProgressRecords(token, taskId) {
  return request.get(`/MyTask/Progress/${taskId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
